import { lazyRegisterServiceworker } from 'owa-serviceworker-cache';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getBrowserInfo, Browser, isMinimumBrowserVersion } from 'owa-user-agent';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function initializeServiceWorker(windowObj: Window, appName: string) {
    const serviceWorkerContainer: ServiceWorkerContainer =
        windowObj.navigator != null && windowObj.navigator.serviceWorker;

    // Enabling service worker only on chrome, firefox
    if (
        serviceWorkerContainer != null &&
        browserSupported() &&
        !isFeatureEnabled('fwk-prefetch-code-off')
    ) {
        const userConfiguration = getUserConfiguration();
        await lazyRegisterServiceworker.importAndExecute(
            windowObj,
            appName,
            userConfiguration.SessionSettings.UserLanguage,
            userConfiguration.UserOptions.IsDarkModeTheme
        );
    } else if (serviceWorkerContainer != null && serviceWorkerContainer.controller != null) {
        serviceWorkerContainer
            .getRegistrations()
            .then((registrations: ServiceWorkerRegistration[]) => {
                for (let i = 0; i < registrations.length; ++i) {
                    registrations[i].unregister();
                }
            });
    }
}

function browserSupported(): boolean {
    const browserInfo = getBrowserInfo();
    return (
        browserInfo.browser == Browser.CHROME ||
        browserInfo.browser == Browser.EDGE_CHROMIUM ||
        browserInfo.browser == Browser.FIREFOX ||
        (isFeatureEnabled('auth-ServiceWorkerEdge') &&
            browserInfo.browser == Browser.EDGE &&
            isMinimumBrowserVersion([17, 17134])) ||
        (isFeatureEnabled('auth-ServiceWorkerSafari') &&
            browserInfo.browser == Browser.SAFARI &&
            isMinimumBrowserVersion([11, 1]))
    );
}
